import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import cx from "classnames";
import {
  Search,
  Grid,
  Visibility,
  Dropdown,
  Segment,
  Placeholder,
  Container,
  Icon,
} from "semantic-ui-react";

import AccountCard from "components/features/Account/Card";

import { fetchAccounts } from "actions/accounts";
import styles from "./accounts.module.scss";
import SortFilter from "components/ui/SortFilter";

import { changeCurrentProduct } from "actions/accounts";

import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
// accounts initial filter options
const initFilters = {
  query: null,
  subscriptions: [],
  sort: "name",
  order: "ASC",
  searchType: "NAME",

};

// subscription filter dropdown options
const subscriptionOptions = [
  { key: 0, text: "Trial", value: "TRIAL" },
  { key: 1, text: "Paid", value: "PAID" },
  { key: 2, text: "Suspended", value: "SUSPENDED" },
  { key: 3, text: "Terminated", value: "TERMINATED" },
];

// search type dropdown options
const searchType = [
  { key: 0, text: "Account", value: "NAME" },
  { key: 1, text: "Email", value: "EMAIL" }
];

// sort filter dropdown options
const sortOptions = [
  { key: 0, text: "Name", value: "name" },
  { key: 1, text: "Newest Customers", value: "created_date" },
  { key: 2, text: "Recently Updated", value: "modified_date" },
];

export default function Accounts(props) {

  const dispatch = useDispatch();
  const params = useParams();

  console.log("params: ", params);

  const loading = useSelector((state) => state.accounts.loading);
  const accounts = useSelector((state) => _.get(state, "accounts.summary"));
  const total = useSelector((state) => _.get(state, "accounts.pagination.totalItemCount")) || 0;

  const [searchText, setSearchText] = useState("");
  const [filters, setFilters] = useState(initFilters);
  const [initialRendering, setInitialRendering] = useState(true);

  useEffect(() => {
    if (!loading) setInitialRendering(false);
  }, [loading]);


  const onSetSearchText = (e) => {
    let value = e.target.value;
    if (!value) {
      setFilters({ ...filters, query: null });
    }

    setSearchText(value);
  };

  const onSearchClick = (e) => {
    setFilters({ ...filters, query: searchText });
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setFilters({ ...filters, query: searchText });
  };

  const onSetSubscriptions = (e, data) => {
    setFilters({ ...filters, subscriptions: data.value, refresh: true });
  };

  const onSetSort = (sort) => {
    let changeOrder = filters.order;
    if (sort === "name") {
      changeOrder = "ASC";
    } else if (sort === "created_date" || sort === "modified_date") {
      changeOrder = "DESC";
    }

    setFilters({ ...filters, sort: sort, order: changeOrder, refresh: false });
  };

  const onSetOrder = (order) => {
    setFilters({ ...filters, order: order, refresh: false });
  };
  const setSearchType = (type) => {
    setFilters({ ...filters, searchType: type });
  }
  
  const accountSegments = () => {
    let segments = [];
    for (var i = 0; i < filters.limit; i++) {
      segments.push(
        <>
          <Grid.Column width={4}>
            <Segment raised className={cx(styles.segmentStyle)}>
              <Placeholder>
                <Placeholder.Header image>
                  <Placeholder.Line />
                  <Placeholder.Line />
                </Placeholder.Header>
                <Placeholder.Paragraph>
                  <Grid>
                    <Grid.Row columns={3}>
                      <Grid.Column width={5}>
                        <Placeholder.Line length="long" />
                      </Grid.Column>
                      <Grid.Column width={5}>
                        <Placeholder.Line length="long" />
                      </Grid.Column>
                      <Grid.Column width={6}>
                        <Placeholder.Line length="long" />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Placeholder.Paragraph>
              </Placeholder>
            </Segment>
          </Grid.Column>
        </>
      );
    }

    return segments;
  };

  return (
    <>
      <Container className={styles.container}>
        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column>
              <h1 className={cx(styles.title)}>
                Accounts <span className={cx(styles.count)}> ({total}) </span>
              </h1>
            </Grid.Column>

            <Grid.Column textAlign="center" width={2}>
              <Dropdown className={cx(styles.searchDropDown)}
                selection
                options={searchType}
                placeholder="Account"
                onChange={(e, { value }) => setSearchType(value)}
              ></Dropdown>
            </Grid.Column>

            <Grid.Column width={6} textAlign="right">
              <form onSubmit={handleSearchSubmit}>
                <Search id="search"
                  input={{
                    icon: (
                      <Icon circular name="search" onClick={onSearchClick} />
                    ),
                    className: cx(styles.searchInput),
                  }}
                  showNoResults={false}
                  value={searchText}
                  onSearchChange={onSetSearchText}
                  placeholder="Search"
                ></Search>
              </form>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row columns={1} className={cx(styles.filterSection)}>
            <Grid.Column>
              <Dropdown
                selection
                multiple
                value={filters.subscriptions}
                onChange={onSetSubscriptions}
                options={subscriptionOptions}
                placeholder="Subscription type"
                closeOnChange
              ></Dropdown>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={2} className={styles.resultsRow}>
            <Grid.Column>
              <Grid.Column width={9}>
                {!loading && filters.query && (
                  <span>
                    {total} results for{" "}
                    <span className={styles.results}> "{filters.query}" </span>
                  </span>
                )}
              </Grid.Column>
            </Grid.Column>
            <Grid.Column textAlign="right">
              <SortFilter
                sort={filters.sort}
                order={filters.order}
                onSortChange={onSetSort}
                onOrderChange={onSetOrder}
                options={sortOptions}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <InfiniteScroll pagination={true} filters={filters}>
          <Grid>
            {initialRendering && (
              <Grid>
                <Grid.Row>{accountSegments()}</Grid.Row>
              </Grid>
            )}

            {!initialRendering && (
              <>
                <Grid.Row>
                  {accounts.map((item, index) => {
                    return (
                      <Grid.Column width={4} key={index}>
                        <AccountCard account={item} />
                      </Grid.Column>
                    );
                  })}
                </Grid.Row>
              </>
            )}
          </Grid>
        </InfiniteScroll>
      </Container>
    </>
  );
}

function InfiniteScroll({
  id,
  children,
  editor,
  pagination,
  filters,
}) {

  const dispatch = useDispatch();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(20);

  const [height, setHeight] = useState(0);
  const [initialised, setInitialised] = useState(false);
  const [visibile, setVisible] = useState(false);

  const loading = useSelector((state) => _.get(state, "accounts.loading"));
  const currentPage = useSelector((state) => _.get(state, "accounts.pagination.pageNumber"));
  const totalPages = useSelector((state) => _.get(state, "accounts.pagination.totalPagesCount"));
  const location = useLocation();
  const selected = location.pathname.includes('/paperflite') ? 'paperflite' : 'cleverstory';

  useEffect(() => {
    if (visibile && !initialised) {
      setInitialised(true);
    }
  }, [visibile]);

  useEffect(() => {
    if (!loading) {
      if (filters.query) {
        filters.query = filters.query.trim();
      }

      const updateProduct = {
        ...filters,
        product: selected
      }

      dispatch(
        fetchAccounts({ page: 0, limit: limit, filters: { ...updateProduct } })
      );
    }
  }, [filters]);

  const handleVisibility = (e, { calculations }) => {

    setHeight(calculations.height + 100);

    if (calculations.onScreen) {
      setVisible(true);
    }

    if (calculations.bottomPassed && !loading && initialised) {
      const nextPage = currentPage + 1;
      const totalPage = totalPages;
      const paginate = pagination && nextPage > 0 && nextPage <= totalPage;

      setPage(nextPage);

      if (paginate) {

        const twoProducts = {
          ...filters,
          product: selected
        }

        dispatch(
          fetchAccounts({
            page: nextPage,
            limit: limit,
            filters: { ...twoProducts },
          })
        );
      }
    }
  };

  return (
    <Visibility
      className={cx(styles.infiniteLoader)}
      updateOn="repaint"
      fireOnMount
      once
      offset={height}
      onUpdate={handleVisibility}
    >
      {children}
    </Visibility>
  );
}
